window.addEventListener('DOMContentLoaded', () => {
    const videoCards = document.querySelectorAll(".videoCard");
    const body = document.querySelector(".template_page_hotdeals_1, .template_page_hotdeals_2, .template_index, .template_page_video_count ,.template_page_spare-parts");
    let scrollTop = 0;

    videoCards.forEach((card) => {

        // initial video playing time range
        const video = card.querySelector('.mediaWrap video');
        if (!video) return;

        // Parse start time from dataset
        const initialBox = card.querySelector('.initialBox');
        let startTime = 0;
        if (initialBox && initialBox.dataset.videostart !== undefined) {
            const parsed = parseFloat(initialBox.dataset.videostart);
            startTime = isNaN(parsed) ? 0 : Math.max(0, parsed);
        }

        video.muted = true; // ensure autoplay works

        const setupLoop = () => {
            const duration = video.duration || 0;
            const endTime = Math.min(startTime + 5, duration);

            if (duration > 0 && startTime < duration) {
                const loopHandler = () => {
                if (video.currentTime >= endTime) {
                    video.pause();
                    video.currentTime = startTime;
                    video.addEventListener('seeked', () => {
                    video.play().catch(() => {});
                    }, { once: true });
                }
                };

                video.addEventListener('seeked', function onSeeked() {
                video.play().catch(() => {});
                video.addEventListener('timeupdate', loopHandler);
                }, { once: true });

                video.currentTime = startTime;
            }
        };

        if (video.readyState >= 1 && !isNaN(video.duration)) {
            setupLoop();
        } else {
            video.addEventListener('loadedmetadata', setupLoop, { once: true });
        }
        // initial video playing time range




        const popUpBtn = card.querySelector(".initialBox");
        const popContainer = card.querySelector(".prodVideo_ContentWrap");
        // const popOverlay = card.querySelector(".popOverlay");
        // const closeBtn = card.querySelector(".closeBtn");
        const mainVideo = card.querySelector(".prodVideo_ContentMain video")
        const video_soundControl = card.querySelector(".prodVideo_ContentMain .soundControl")

        // open popup
        popUpBtn.addEventListener("click", function () {
            scrollTop = window.scrollY; // store scroll position
            popContainer.classList.add("active");
            body.classList.add("noScroll");
            body.style.top = `-${scrollTop}px`; // lock at current section position
            mainVideo.play();
            initAllCards();
        });

        // Close popup when overlay / close button clicked
        function closePopup() {
            popContainer.classList.remove("active");
            body.classList.remove("noScroll");
            body.style.top = ""; // reset style
            window.scrollTo(0, scrollTop); // restore scroll position
            if (mainVideo) {
                mainVideo.pause();
                mainVideo.currentTime = 0;
            }
        }

        video_soundControl.addEventListener("click", function(){
            if ($(this).hasClass('unmute')) {
                $(this).removeClass('unmute');
                mainVideo.muted = true;
            } else {
                $(this).addClass('unmute');
                mainVideo.muted = false;
            }
        });

        // popOverlay.addEventListener("click", closePopup);
        // closeBtn.addEventListener("click", closePopup);
    });

    
});